'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var validators_1 = require("./validators");

function componentToHex(c) {
  var hex = c.toString(16);
  return hex.length === 1 ? '0' + hex : hex;
}

function rgbaToHex(color) {
  var r = Math.floor(color.r * color.a);
  var g = Math.floor(color.g * color.a);
  var b = Math.floor(color.b * color.a);
  return "#".concat(componentToHex(r)).concat(componentToHex(g)).concat(componentToHex(b));
}

var Color = /*#__PURE__*/function () {
  function Color(r, g, b) {
    var a = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, Color);

    validators_1.validateAlphaValue(a);
    this.r = r;
    this.g = g;
    this.b = b;
    this.a = a;
  }

  _createClass(Color, [{
    key: "toRGBString",
    value: function toRGBString() {
      return "rgb(".concat(Math.floor(this.r * this.a), ",").concat(Math.floor(this.g * this.a), ",").concat(Math.floor(this.b * this.a), ")");
    }
  }, {
    key: "toRGBAString",
    value: function toRGBAString() {
      return "rgba(".concat(this.r, ",").concat(this.g, ",").concat(this.b, ",").concat(this.a, ")");
    }
  }, {
    key: "toHexString",
    value: function toHexString() {
      return rgbaToHex(this);
    }
  }]);

  return Color;
}();

module.exports = Color;